import axios from 'axios';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getAllSections(_obj, params) {
    const res = await axios.get(`api/sections/`, { params });
    return res.data;
  },

  async getSection(_obj, id) {
    const res = await axios.get(`api/sections/${id}/`);
    return res.data;
  },

  async createSection(_obj, data) {
    return axios.post(`api/sections/`, data);
  },

  async updateSection(_obj, { id, data }) {
    return axios.patch(`api/sections/${id}/`, data);
  },

  async deleteSection(_obj, id) {
    return axios.delete(`api/sections/${id}/`);
  },
  async getQuestionCount(_obj, data) {
    return (await axios.post(`api/sections/question-count/`, data)).data.data;
  },
  async getPublicSections(_obj, params) {
    const res = await axios.get(`api/sections/public-section-list/`, { params });
    return res.data;
  }
};

export const sections = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
